//#region ImportsSection
import { t } from "i18next";
import React, { useState } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert";
import { isUrdu, LoadingSpinner } from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import ApiHabibProgress from "./ApiHabibProgress";
//#endregion ImportsSection
const AddHabibProgress = ({ setAddModal, refresh, setRefresh }) => {
  //#region StateSection
  const [progressName, setprogressName] = useState("");
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  //#endregion StateSection

  //#region functionSection
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.progressName = progressName ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setprogressName(value);
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setButtonDisable(true);
      ApiHabibProgress()
        .AddSetupHabibProgress({
          progressName: progressName,
          id: 0,
        })
        .then((res) => {
          console.log(res);
          if (res.data.statusCode === "200") {
            swal({
              title: t("added_habib_progress"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
          } else {
            swal({
              title: t("common_error_message"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "error",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
          }
          setRefresh(!refresh);
          setAddModal(false);
          setLoading(false);
          setButtonDisable(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
          setButtonDisable(false);
        });
    }
  };
  //#endregion functionSection

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="add_habib_progress_name" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="habib_progress_name" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="tagName"
                  className={isUrdu(progressName) ? "no-drag ur" : "no-drag"}
                  value={progressName}
                  onChange={handleInputChange}
                  {...(errors?.progressName && { invalid: true })}
                />
                {errors?.progressName && (
                  <FormFeedback>
                    <h4>{errors?.progressName}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => setAddModal(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit" disabled={buttonDisable}>
                <GetLanguageString props="common_save" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default AddHabibProgress;
